import './SimpleSlider.scss';
import React, { Component } from "react";
import Slider from "react-slick";

export default class SimpleSlider extends Component {
  
    render() {
      const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
      };
      return (
        <div>
          <Slider {...settings} className="slider_list">
            <div>
              <p>CX True Wireless</p>
              <img src="/img/slider1.png" alt=""></img>
            </div>
            <div>
              <p>CX plus True Wireless</p>
              <img src="/img/slider2.png" alt=""></img>
            </div>
          </Slider>
        </div>
      );
    }
  }

